// Sets/clears the Sentry user context from auth.me. No PII (no email/phone).
// Renders nothing. No-ops when Sentry isn't initialised (setUser is safe to call).
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { trpc } from '@/lib/trpc';

export function SentryUser() {
  const { data: me } = trpc.auth.me.useQuery(undefined, { staleTime: 5 * 60 * 1000 });
  useEffect(() => {
    if (me?.id) Sentry.setUser({ id: String(me.id), username: me.name ?? undefined });
    else Sentry.setUser(null);
  }, [me?.id, me?.name]);
  return null;
}
